import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { EchoTokenService } from '../../services';

export const echoTokenGuard: CanActivateFn = (route, state) => {
  const echoTokenService = inject(EchoTokenService);

  const echoToken = route.queryParamMap.get('echoToken');
  if (echoToken) {

    echoTokenService.storeToken(echoToken);
    return true;
  }

  return true;
};
